import UsersActions from "../components/GridTableUtils/UsersActions";

export const columnsUsersList = [
    {
        field: 'firstName',
        headerName: 'First Name',
        flex: 1
    },
    {
        field: 'lastName',
        headerName: 'Last Name',
        flex: 1
    },
    {
        field: 'email',
        headerName: 'Email',
        flex: 1
    },
    {
        field: 'type',
        headerName: 'Type',
        flex: 1,
        valueFormatter: (value)=> {
            switch (value) {
                case "manager":
                    return "Manager"
                case "direct":
                    return "Direct Report"
                case "peer":
                    return "Peer"
                case "otherColleague":
                    return "Other Colleague"
                default:
                    return "Assign Type..."
            }
        }

    },
    {
        field: 'status',
        headerName: 'Status',
        flex: 1
    },
    {
        field: 'actions',
        headerName: 'ACTIONS',
        flex: 1,
        renderCell: UsersActions
    },
];